import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell, TableRow } from '@material-ui/core';
import SelectGroupButton from './SelectGroupButton';


const GroupTableRow = ({ group, handleCloseModal }) => {
  const {
    label,
    value,
  } = group;

  const { options } = useSelector((state: IReduxState) => state.eavAttributes);
  const customersByMarketingSegment = options.find((option) => option.value === value)?.total_count || 0;

  return (
    <TableRow>
      <TableCell>{label}</TableCell>
      <TableCell>{customersByMarketingSegment}</TableCell>
      <TableCell align="right" className="pr-0">
        <SelectGroupButton
          group={group}
          handleCloseModal={handleCloseModal}
          isDisabled={customersByMarketingSegment === 0}
        />
      </TableCell>
    </TableRow>
  );
};

export default GroupTableRow;
